import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadGuitar = () => {
  const promiseGuitar = new Promise((resolve, reject) => {
    loader.load(
      "office/model/guitar.gltf",
      function (guitar) {
        scene.add(guitar.scene);
        const guitarMesh = guitar.scene;
        guitarMesh.position.set(
          -1.4290406914147913, 1.18960262872021, 9.994511743329436);
        guitarMesh.rotation.set(
          3.124994866399992, 0.004458775448592385, 3.1392298063816026
        );

        guitarMesh.scale.set(0.005, 0.005, 0.005);

       // ControlFunction(guitarMesh);

        guitarMesh.traverse(function (object) {
          if (object.isMesh) {
            object.castShadow = true;
            object.receiveShadow = false;
          }
        });

        resolve(guitarMesh);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
  });
  return promiseGuitar;
};

export { loadGuitar };
